export type GuidelineTag = {
  message?: string;
  status?: GuidelineTagStatus;
  isActive?: boolean;
};

export enum GuidelineTagStatus {
  DEFAULT = 0,
  NEW = 1,
  UPDATED = 2,
  DELETED = 3,
  CHILD_UPDATED = 4,
}
